import { useTranslation } from 'react-i18next';

interface ReservationIntroSectionProps {
  keyType: 'physical_key_only' | 'digital';
}

/**
 * 予約完了画面のイントロセクション
 */
export const ReservationIntroSection = ({
  keyType,
}: ReservationIntroSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="f6__intro">
      <div className="f6__intro-text">
        {t('shareDevice.complete.introText')}
        <br />
        {keyType === 'physical_key_only' ? (
          <>
            {t('shareDevice.complete.introDescriptionPhysicalKeyBefore')}
            <span className="f6__intro-color">
              {t('shareDevice.complete.introHighlightPhysicalKey')}
            </span>
          </>
        ) : (
          <>
            <span className="f6__intro-color">
              {t('shareDevice.complete.introHighlight')}
            </span>
            {t('shareDevice.complete.introDescription')}
          </>
        )}
      </div>
    </div>
  );
};
